// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__13uDS","label":"Labeled_label__1tUQO","divider":"Labeled_divider__2w64K"};